/* "New" badge on USF collection cards.
 *
 * The theme's own product cards get the badge from snippets/new-badge.liquid. The collection pages are drawn by the USF
 * app instead, so this adds the same badge to those cards using each card's own product data.
 * Same rule as the Liquid snippet: the product was added (created) in the last N days (theme setting "New badge",
 * default 180; 0 = off), and never for leather / vinyl swatches. USF calls the creation time "date".
 * N and the label come from window.wellingtonsNewBadge, set in snippets/usf.liquid.
 * Styles: ".productitem__badge--new" in assets/custom.css.
 *
 * Loaded on collection pages only. If USF's card data is ever missing, cards simply get no badge.
 */
(function () {
  'use strict';

  var cfg = window.wellingtonsNewBadge || {};
  var days = typeof cfg.days === 'number' ? cfg.days : 180;
  var label = cfg.label || 'New';
  var DAY = 86400000;
  var SWATCH = { 'Leather Swatch': true, 'Vinyl Swatch': true };
  var timer = null;

  if (!(days > 0)) { return; }

  function isNew(product) {
    if (!product || !product.date || SWATCH[product.productType]) { return false; }
    /* USF sends e.g. 2026-08-27T14:09:45.0000000Z; drop the fraction so every browser parses it */
    var added = Date.parse(String(product.date).replace(/\.\d+/, ''));
    if (isNaN(added)) { return false; }
    var age = (Date.now() - added) / DAY;
    return age >= 0 && age <= days;
  }

  function decorate(card) {
    var vm = card.__vue__, figure = card.querySelector('.productitem--image');
    if (!vm || !vm.product || !figure) { return; }
    var badge = figure.querySelector('.productitem__badge--new');
    if (isNew(vm.product)) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'productitem__badge productitem__badge--new';
        badge.textContent = label;
        figure.appendChild(badge);
      }
    } else if (badge) {
      badge.parentNode.removeChild(badge);   /* USF re-used this card for a different product (e.g. next page) */
    }
  }

  function run() {
    timer = null;
    var cards = document.querySelectorAll('#usf_container li[data-product-item]'), i;
    for (i = 0; i < cards.length; i++) { decorate(cards[i]); }
  }

  function schedule() {
    if (timer === null) { timer = setTimeout(run, 40); }   /* a timer, not requestAnimationFrame: that pauses in background tabs */
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
